import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {from, Observable, of, throwError} from 'rxjs';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';

import {iClient} from '../Model/ClientModel';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  private httpOptions: any;
  token:any

  constructor(private httpClient: HttpClient,
              private authService: AuthService,
              private router: Router) {
  }

  getAllPatients(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}patient`, params);
  }

  getPatientDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}patient`, params);
  }

  patientRegistration(patient): Observable<any> {
    return this.authService.post(`${environment.patientService}patient`, patient);
  }

  updatePatient(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.patientService}patient`,body, params);
  }

  searchPatient(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}patient/search`, params);
  }

  patientBulkUpload(data,params): Observable<any> {
    return this.authService.postD(`${environment.patientService}patient`, data, params);
  }

  assignPatient(body: any, params?:any): Observable<any> {
    return this.authService.patchP(`${environment.patientService}patient`,body, params);
  }

  filterPatient(params: HttpParams): Observable<any> {
    // Preserve repeated query keys such as payerIds=25&payerIds=31.
    return this.authService.getWithHttpParams(`${environment.patientService}patient`, params);
  }

  getAllProvider(params?:any): Observable<any> {
    return this.authService.getP(`${environment.userService}provider`, params);
  }

  getPayer(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}payer`, params);
  }


  getAgents(params?:any): Observable<any> {
    return this.authService.getP(`${environment.userService}user`, params);
  }
  runBatchJob(params?:any): Observable<any> {
    return this.authService.getP(`${environment.batchJob}patient`, params);
  }

  filterDateWOD(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}patient`, params);
  }
}
